// Angular modules.
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { dummyUserId } from 'app/constants';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IBusySlot } from 'app/interfaces/availability.interface';
import { CalendarNavState } from 'app/interfaces/calendar.interface';
import { ApiErrorResponse } from 'app/interfaces/error.interface';
// Zenklub interfaces.
import {
	EventPrice,
	ICalendarEvent,
	IConfirmEvent,
	INewEvent,
	IUpdateEvent,
} from 'app/interfaces/event.interface';
import { IZkuProfessional } from 'app/interfaces/professionalprofile.interface';
import { ITaxonomy } from 'app/interfaces/search.interface';
import { ProfessionalSubscriptionResponse } from 'app/interfaces/subscription.interface';
import { IUserPreferences } from 'app/interfaces/userpreferences.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { AvailabilitiesService } from 'app/services/availabilities.service';
import { ContactsService } from 'app/services/contacts.service';
// Zenklub services.
import { CurrencyService } from 'app/services/currency.service';
import { DateTimeService } from 'app/services/datetime.service';
import { EventsService } from 'app/services/events.service';
import { NetworkService } from 'app/services/network.service';
import { SubscriptionService } from 'app/services/subscription.service';
import { TaxonomyService } from 'app/services/taxonomy.service';
import { CheckTriage, TriageService } from 'app/services/triage.service';
import { UserService } from 'app/services/user.service';
import { ZkuService } from 'app/services/zku.service';
import { SelectedClient } from 'app/shared/client-search/client-search.component';
// Global
import { environment } from 'environments/environment';
import * as $ from 'jquery';
import { SessionService } from 'modules/video-conference/services/session/session.service';
import * as moment from 'moment-timezone';
// Third-party modules.
import { SelectItem } from 'primeng/api';
import { Observable, forkJoin } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { IChatUser } from '../../../interfaces/chatuser.interface';
import { ChatService } from '../../../services/chat.service';

@Component({
	selector: 'app-mobappointments-manage',
	templateUrl: './mobappointments-manage.component.html',
	styleUrls: ['./mobappointments-manage.component.scss'],
})
export class MobAppointmentsManageComponent implements OnInit {
	// Inputs.
	@Input() calendarLabels: any;
	@Input() editId: string;
	@Input() addNew: boolean;
	@Input() contactId: number;
	@Input() operationType: string;
	@Input() returnTo: CalendarNavState;
	@Input() sessionDate: Date;
	// Outputs.
	@Output() changeScreen: EventEmitter<string> = new EventEmitter<string>();
	// Status.
	isLoading = false;
	editMode = false;
	isEditableEvent = true;
	isReschedule = false;
	allowConference = false;
	allowReschedule = false;
	rescheduleMode = false;
	// event type
	eventTypes: SelectItem[];
	// Inputs for add new event.
	sessionDateString: string;
	eventPrice: string;
	selectedHourFrom: string;
	selectedHourTo: string;
	inputHourFrom: string;
	inputHourTo: string;
	userSelectedId: string;
	tag: number;
	description: string;
	// Client data.
	showNameSelect: boolean;
	selectedClient?: SelectedClient;
	// Edit event data.
	editEvent: ICalendarEvent | any = {};
	busySlot: IBusySlot;
	editOriginalDate: Date;
	editOriginalDateStr: string;
	editOriginalValue: number;
	userRequestedReschedule = false;
	lastUpdatedAt: Date;
	// Labels.
	duration: number;
	screenDate: string;
	startHours: string;
	originalDateFrom: string;
	originalDateTo: string;
	originalStartHours: string;
	eventStatusLabel: string;
	endHours: string;
	utcInfo: string;
	appointDate: string;
	professionalProfit: EventPrice | any = { extraInfo: [] };
	// User's preferences.
	userPref: IUserPreferences;
	currentTimezone: string;
	currentOffset: string;
	// Size control.
	paddingName = '15px 0';
	// Translated strings.
	strAreYouSure: string;
	strInvalidDate: string;
	strInvalidHour: string;
	strInviteWasSent: string;
	strNewSession: string;
	strNewEvInvalidType: string;
	strNewEvInvalidDate: string;
	strNewEvInvalidHour: string;
	strNewEvInvalidClient: string;
	strNewEvInvalidPrice: string;
	strNoConnection: string;
	strReschedule: string;
	strToDateMustBeGreater: string;
	// Contact reasons
	reasons: readonly ITaxonomy[];
	selectedReason = '0';
	selectedReasons: ITaxonomy[] = [];
	showConfirmSessionFinished = false;

	voucherDescription: string;
	contact;
	isFirstSession = false;
	isPremium = false;
	showChatButton = false;

	triage$: Observable<CheckTriage>;
	hasTriage: boolean;
	triage: CheckTriage & { mainComplaintText: string };
	showTriageData = false;
	isProfessionalZen = false;
	professionalZkuService: IZkuProfessional;

	// Constructor method.
	constructor(
		private chat: ChatService,
		protected currency: CurrencyService,
		protected dateTime: DateTimeService,
		protected events: EventsService,
		protected network: NetworkService,
		protected notifications: ZkNotificationService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService,
		protected userService: UserService,
		protected contacts: ContactsService,
		protected availabitiesService: AvailabilitiesService,
		protected taxonomy: TaxonomyService,
		protected subscriptionService: SubscriptionService,
		protected triageService: TriageService,
		private zkuService: ZkuService,
		private sessionService: SessionService,
		private actionTrackerService: ActionTrackerService
	) {
		this.professionalZkuService = this.zkuService.getZku();

		if (
			this.professionalZkuService !== undefined &&
			this.professionalZkuService?.tags?.some(
				(tag) => tag['id'] === 'professional_zen'
			)
		) {
			this.isProfessionalZen = true;
		}
	}

	// On init.
	public ngOnInit(): void {
		// Is loading.
		this.isLoading = true;
		// Get current time zone info.
		this.currentTimezone = this.dateTime.getBrowserTimezone();
		// Get user preferences.
		this.userPref = this.userService.getUserLocalPreferences();
		this.eventPrice = this.currency.formatWithDecimals(
			this.userPref.SessionValue
		);
		this.currentOffset = this.dateTime.getHoursToUTC();

		this.hasTriage = false;

		// Get translated texts. and taxonomy
		forkJoin([
			this.translate.get([
				'ERROR.NOCONNECTION',
				'GENERAL.RESCHEDULE',
				'MESSAGES.AREYOUSURE',
				'MESSAGES.INVALIDDATE',
				'MESSAGES.INVALIDHOUR',
				'MESSAGES.NEWEVENT.INVITEWASSENT',
				'MESSAGES.NEWEVENT.NOCLIENT',
				'MESSAGES.NEWEVENT.NOEVENTPRICE',
				'MESSAGES.NEWEVENT.NOEVENTTYPE',
				'MESSAGES.NEWEVENT.WRONGDATE',
				'MESSAGES.NEWEVENT.WRONGHOURTO',
				'SCHEDULE.NEWSESSION',
				'SCHEDULE.SESSIONTYPES.ONLINE',
				'SCHEDULE.SESSIONTYPES.PRESENTIAL',
				'SCHEDULE.SESSIONTYPES.PERSONAL',
				'SCHEDULE.SESSIONTYPES.UNAVAILABILITIES',
				'MESSAGES.TODATEMUSTBEGREATER',
			]),
			this.taxonomy.getTaxonomyReasons(),
		]).subscribe(([res, reasons]) => {
			this.reasons = reasons;
			// Strings.
			this.strAreYouSure = res['MESSAGES.AREYOUSURE'];
			this.strInvalidDate = res['MESSAGES.INVALIDDATE'];
			this.strInvalidHour = res['MESSAGES.INVALIDHOUR'];
			this.strInviteWasSent = res['MESSAGES.NEWEVENT.INVITEWASSENT'];
			this.strNewSession = res['SCHEDULE.NEWSESSION'];
			this.strNewEvInvalidType = res['MESSAGES.NEWEVENT.NOEVENTTYPE'];
			this.strNewEvInvalidDate = res['MESSAGES.NEWEVENT.WRONGDATE'];
			this.strNewEvInvalidHour = res['MESSAGES.NEWEVENT.WRONGHOURTO'];
			this.strNewEvInvalidClient = res['MESSAGES.NEWEVENT.NOCLIENT'];
			this.strNewEvInvalidPrice = res['MESSAGES.NEWEVENT.NOEVENTPRICE'];
			this.strNoConnection = res['ERROR.NOCONNECTION'];
			this.strReschedule = res['GENERAL.RESCHEDULE'];
			this.strToDateMustBeGreater = res['MESSAGES.TODATEMUSTBEGREATER'];
			this.eventTypes = [];
			this.eventTypes.push({
				label: res['SCHEDULE.SESSIONTYPES.UNAVAILABILITIES'],
				value: 'availability',
			});
			this.eventTypes.push({
				label: res['SCHEDULE.SESSIONTYPES.ONLINE'],
				value: 'online',
			});
			this.eventTypes.push({
				label: res['SCHEDULE.SESSIONTYPES.PERSONAL'],
				value: 'personal',
			});

			if (this.editId) {
				this.editMode = true;
				if (this.operationType === 'personal') {
					this.availabitiesService.getBusySlot(this.editId).then((event) => {
						this.description = event.description;
						const startD: Date = new Date(event.startDate);
						const endD: Date = new Date(event.endDate);
						const startH: number = startD.getHours();
						const startM: number = startD.getMinutes();
						const endH: number = endD.getHours();
						const endM: number = endD.getMinutes();
						this.startHours = this.dateTime.getFormatedHoursAlt(startH, startM);
						this.endHours = this.dateTime.getFormatedHoursAlt(endH, endM);
						this.utcInfo = this.dateTime.getBrowserTimezone();
						this.busySlot = event;

						this.screenDate = this.dateTime.getInFullDate(startD);
					});
				} else {
					this.events.getEvent(this.editId).then(async (event) => {
						if (event) {
							// Check if appointment is not confirmed and it has already started
							const now = new Date().getTime();
							const appointmentStartTime = new Date(event.day).getTime();
							this.showConfirmSessionFinished =
								event.status === 'paid' && now > appointmentStartTime;

							// Store event.
							this.editEvent = event;

							this.sessionService
								.getData(this.editEvent.id)
								.toPromise()
								.then((session) => {
									this.isFirstSession = session.numberOfSessions === 1;
								});

							this.contacts
								.getContact(this.editEvent.contactId)
								.toPromise()
								.then((contact) => {
									this.contact = contact;
								});
							if (event.triageId) {
								this.checkTriage(event);
							}

							this.editEvent.userImageUrl = await this.contacts.getContactImage(
								event
							);
							this.duration = res.isHalfHourSession ? 30 : 50;
							// Can edit?
							// this.isEditableEvent = this.events.isEditable(event);
							this.isEditableEvent = this.events.allowReschedule(event);
							this.editMode = this.isEditableEvent;
							// Allow reschedule?
							this.allowReschedule = this.events.allowReschedule(event);
							// Event date.
							this.sessionDate = undefined;
							this.sessionDateString = this.dateTime.getStringDate(event.day);
							// Event time.
							this.selectedHourFrom = undefined;
							this.selectedHourTo = undefined;
							this.inputHourFrom = this.selectedHourFrom;
							this.inputHourTo = this.selectedHourTo;
							// Original value.
							this.eventPrice = this.currency.formatWithDecimals(event.price);
							// Label for event status.
							this.eventStatusLabel = this.events.getLabelClass(event.status);
							// Force reset of original dates (reschedule only).
							this.originalDateFrom = null;
							this.originalDateTo = null;
							if (event.reschedule && event.reschedule.rescheduleUtcStartDate) {
								// Reschedule to date.
								if (event.status === 'reschedule') {
									const offset: number = this.dateTime.getTimezoneOffset();
									const newDate: Date = this.dateTime.getLocalDate(
										event.reschedule.rescheduleUtcStartDate,
										offset
									);
									this.originalDateTo = this.dateTime.getTranslatedDate(
										newDate,
										true
									);
								}
								// Rescheduled from date.
								if (
									event.status === 'reschedule_request' ||
									event.status === 'paid'
								) {
									const oldDate: Date = new Date(
										event.reschedule.rescheduleUtcStartDate
									);
									this.originalDateFrom = this.dateTime.getTranslatedDate(
										oldDate,
										true
									);
								}
							}
							// Selected client.
							this.selectedClient = {
								id: event.contactId ? Number(event.contactId) : 0,
								profileId: event.profileId,
								name: event.userName,
							};
							// Local date.
							const startD: Date = new Date(event.day);
							// Get unabbreviated date for session.
							this.screenDate = this.dateTime.getInFullDate(startD);
							this.startHours = event.startTime;
							this.endHours = event.endTime;
							this.utcInfo = this.dateTime.getBrowserTimezone();
							const auxReasons = event.contactReason ? event.contactReason : [];
							// Contact reason value
							this.selectedReasons = auxReasons
								.map((auxId) =>
									this.reasons.find((reason) => reason.id === auxId)
								)
								.filter((t) => t);
							// Voucher
							this.voucherDescription = event.voucherDescription;
							// Doctor's profit.
							this.professionalProfit = this.events.getEventPriceToShow(event);
							// Padding control.
							this.paddingName =
								event.userName.length > 17 ? '7px 0' : '15px 0';
							// Date of appointment.
							this.appointDate = this.dateTime.getInFullDate(
								new Date(event.createdAt)
							);
							// Loaded.
							this.isLoading = false;
							// Configure elements.
							this.onResize('evForm');

							if (event.status === 'paid') {
								// Get original session value.
								this.editOriginalValue = event.price;
								this.editOriginalValue = this.events.isDateInThePast(event.day)
									? 0
									: event.price;

								// Get unabbreviated date for session.
								this.editOriginalDate = event.day;
								const dt = this.dateTime.getInFullDate(event.day);
								this.editOriginalDateStr = dt + ' - ' + event.startTime;
							}

							if (event.profileId && event.profileId !== dummyUserId) {
								this.showChatButton = true;
							}
							this.showChatButton =
								event.status === 'reserved' ? false : this.showChatButton;
						}
					});
				}
			} else {
				// Add new.
				this.editMode = false;
				// Active date.
				this.sessionDate = new Date();
				// Start and end time.
				if (!this.selectedHourFrom) {
					const d: Date = new Date();
					const h: number = d.getHours() + 1;
					const hTo: number = h < 23 ? h + 1 : 0;
					this.selectedHourFrom = this.dateTime.getHourString(h, 0);
					this.selectedHourTo = this.dateTime.getHourString(hTo, 0);
					this.inputHourFrom = this.selectedHourFrom;
					this.inputHourTo = this.selectedHourTo;
					this.duration = 50;
				}
				if (this.addNew && this.contactId) {
					this.getClientData();
					this.showNameSelect = false;

					// Loaded.
					this.isLoading = false;
					// Configure elements.
					this.onResize('evForm');
				} else {
					// Loaded.
					this.showNameSelect = true;
					this.isLoading = false;
					// Configure elements.
					this.onResize('evForm');
				}
			}
		});

		this.subscriptionService.getSubscriptionList().subscribe(
			(response: ProfessionalSubscriptionResponse) => {
				this.isPremium = response.subscriptions.some((sub) => {
					return [
						'active',
						'requested_cancelation',
						'cancelation_accepted',
					].includes(sub.status);
				});
				this.isLoading = false;
			},
			(error: ApiErrorResponse) => {
				this.notifications.showError(
					error.toString(),
					this.translate.instant('PAGES.MEMBERSHIP.MESSAGES.ERROR')
				);
				// this.isLoading = false;
			}
		);
	}
	//TODO: remover essa validaçao quando disponibilizarmos recibo para os anos anteriores a 2022
	isSessionThisYear(sessionDate) {
		const sessionYear = moment(sessionDate).year();
		return sessionYear >= 2021;
	}

	showReceiptButton() {
		if (
			this.dateTime.dateTimeIsAfter(this.editEvent.dayEnd) ||
			!this.editEvent.isB2C
		) {
			return false;
		}
		return (
			this.editEvent.status === 'paid' &&
			(this.editEvent.price > 0 || this.editEvent.b2cPaidPrice > 0) &&
			this.isSessionThisYear(this.editEvent.dayEnd)
		);
	}

	formatTriageReasons() {
		return this.triage?.reasonsForTherapy?.reasons
			?.map((reason) => {
				if (typeof reason === 'string') return reason;
				return reason.OTHER;
			})
			.join(', ');
	}

	public selectedClientChanged(val?: SelectedClient): void {
		this.selectedClient = val;
		if (val) {
			this.contactId = this.selectedClient.id;
			this.getClientData();
		}
	}

	public trackPromptuaryListRedirect() {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Caledar,
			SUBSCOPE_TYPE.Session,
			ITEM_TYPE.BtnPromptuaryList,
			INTERACTION_TYPE.Click,
			{}
		);
	}

	// Get client data for new event.
	private async getClientData() {
		this.contacts.getContact(this.contactId).subscribe((contact) => {
			this.selectedClient = {
				id: contact.id,
				profileId: contact.refUserId,
				name: contact.displayName,
			};
			if (contact.sessionPriceHalfHour && this.duration === 30) {
				this.eventPrice = this.currency.formatWithDecimals(
					contact.sessionPriceHalfHour
				);
			} else if (contact.sessionPrice) {
				this.eventPrice = this.currency.formatWithDecimals(
					contact.sessionPrice
				);
			}
		});
	}

	// When from hour is selected.
	public fromHourSelected(): void {
		const parsedHour: string = this.inputHourFrom.slice(0, 2);
		const parsedMin: string = this.inputHourFrom.slice(2, 4).padEnd(2, '0');
		// Get from hours/minutes.
		const hourFrom: number = parseInt(parsedHour, 10);
		// Set to hours/minutes.
		const hourTo: number = hourFrom < 23 ? hourFrom + 1 : 0;
		// Update hour to.
		this.inputHourTo = `${hourTo.toString().padStart(2, '0')}:${parsedMin}`;
	}

	public formatHourStrings() {
		const parsedFromHour: string = this.inputHourFrom
			.replace(':', '')
			.slice(0, 2)
			.padStart(2, '00');
		const parsedFromMin: string = this.inputHourFrom
			.replace(':', '')
			.slice(2, 4)
			.padEnd(2, '00');

		this.selectedHourFrom = `${parsedFromHour}:${parsedFromMin}`;
		this.inputHourFrom = this.selectedHourFrom;

		const parsedToHour: string = this.inputHourTo
			.replace(':', '')
			.slice(0, 2)
			.padStart(2, '0');
		const parsedToMin: string = this.inputHourTo
			.replace(':', '')
			.slice(2, 4)
			.padEnd(2, '0');
		this.selectedHourTo = `${parsedToHour}:${parsedToMin}`;
		this.inputHourTo = this.selectedHourTo;
		this.setDuration(parsedFromMin, parsedToMin);
	}

	private setDuration(parsedFromMin: string, parsedToMin: string) {
		if (Number(parsedFromMin) > Number(parsedToMin)) {
			this.duration =
				Number(parsedFromMin) - Number(parsedToMin) <= 30 ? 30 : 50;
		} else {
			this.duration =
				Number(parsedToMin) - Number(parsedFromMin) <= 30 ? 30 : 50;
		}
	}

	// Clear annotations inside fields with errors.
	public clearFieldErrors(field?: string): void {
		$(field || '.tempError')
			.removeClass('fieldError')
			.removeClass('tempError');
	}

	// When window is resized.
	public onResize(container: string): void {
		container = container !== 'evForm' ? 'evDetails' : 'evForm';
		if ($('.' + container).length > 0) {
			// Form elements.
			const formContainer: JQuery<HTMLElement> = $('.apDetails-session');
			const inpSessionDate: JQuery<HTMLElement> = $('#inpNewSessionDate');
			const inpTime: JQuery<HTMLElement> = $('.inpTime');
			// Get reference container width.
			const contW: number = formContainer.width();
			// Configure calendar field.
			inpSessionDate.css('width', contW);
			// Configure time related fields.
			const timeLabelT: JQuery<HTMLElement> = $('.td-add-session-label.lblTo');
			const timeLabelsW: number = timeLabelT.width();
			const timeLabelsFinalW: number = (contW - timeLabelsW) / 2 - 20;
			inpTime.css('width', timeLabelsFinalW);
			inpTime.css('text-align', 'center');
			// Hide 'x' of calendar field.
			const owlDtCancel: JQuery<HTMLElement> = $('.owl-dateTime-cancel');
			if (owlDtCancel.length > 0) {
				owlDtCancel.hide();
			}
			// Calendar icon.
			const inpNewSessionDate: JQuery<HTMLElement> = $('#inpNewSessionDate');
			if (inpNewSessionDate && inpNewSessionDate.length > 0) {
				let inpTop: number = inpNewSessionDate.position().top;
				inpTop =
					navigator.platform.indexOf('iPhone') > -1 ? inpTop + 22 : inpTop - 32;
				$('.owl-dateTime-cancel').hide();
				const faCal: JQuery<HTMLElement> = $('.iconCal');
				faCal.css('margin-top', inpTop);
				faCal.css('position', 'absolute');
				faCal.css('right', '40px');
			} else {
				setTimeout(() => {
					this.onResize('evDetails');
				}, 100);
			}
			// Configure search field.
			const fcCliVal: JQuery<HTMLElement> = $('.fcCliVal');
			const searchInput: JQuery<HTMLElement> = $('#inpSearch');
			const searchButton: JQuery<HTMLElement> = $(
				'.fcCliVal .ui-autocomplete-dropdown'
			);
			if (searchInput.length > 0 && searchButton.length > 0) {
				const fcW: number = fcCliVal.width();
				const sbW: number = searchButton.width();
				searchInput.css('width', fcW - sbW - 25);
			}
		} else {
			setTimeout(() => {
				this.onResize(container);
			}, 100);
		}
	}

	// Go to options list.
	public viewOptionsList(): void {
		this.changeScreen.emit('Options');
	}

	// Operation type changed.
	public opTypeSelected(): void {
		if ('availability' === this.operationType) {
			this.goToPage(this.operationType);
		}
	}

	// Navigate.
	goToPage(page: string, params?: any): void {
		page = this.returnTo.returnTo || page;
		switch (page.toLowerCase()) {
			case '/':
			case 'calendar':
			case 'dashboard':
			case 'home':
				this.router.navigate(params ? ['/calendar', params] : ['/calendar'], {
					state: { ...this.returnTo },
				});
				break;
			case 'availability':
				this.router.navigate(['availabilities'], {
					state: { ...this.returnTo },
				});
				break;
			case 'clients':
				this.router.navigate(['clients'], { state: { ...this.returnTo } });
				break;
			default:
				this.router.navigate(['calendar'], { state: { ...this.returnTo } });
				break;
		}
	}

	// Return to previous page.
	public returnToPrevious(): void {
		if (this.returnTo && this.returnTo.returnTo) {
			this.goToPage(this.returnTo.returnTo);
		} else {
			this.viewOptionsList();
		}
	}

	public unselectReason(id: string): void {
		this.selectedReasons = this.selectedReasons.filter(
			(item) => item.id !== id
		);
	}
	public changeReason(): void {
		if (this.selectedReason === '0') {
			return;
		}
		if (
			this.selectedReasons &&
			this.selectedReasons.length < environment.maxProfessionalComplaints
		) {
			let found = false;
			this.selectedReasons.forEach((item) => {
				if (String(item.id) === this.selectedReason) {
					found = true;
					return false;
				}
			});

			if (!found) {
				let reasonObj: any;
				this.reasons.forEach((item) => {
					if (String(item.id) === this.selectedReason) {
						reasonObj = item;
					}
				});
				this.selectedReasons.push(reasonObj);
			}
			// Reset selected.
			this.selectedReason = '';
		} else {
			this.notifications.showError(
				this.translate.instant('PAGES.ACCOUNT.ERRORS.COMPLAINTSLIMIT', {
					limit: environment.maxProfessionalComplaints,
				})
			);
		}
	}

	// Save new event.
	public async save() {
		// Loading.
		this.isLoading = true;
		// Check connectivity.
		if (!this.network.checkConnectivity()) {
			this.notifications.showError(this.strNoConnection, this.strNewSession);
		} else {
			// Submit.
			if (this.validateForm()) {
				// Clear field errors.
				this.clearFieldErrors();

				// Date info.
				const startHours: number = parseInt(
					this.selectedHourFrom.split(':')[0],
					10
				);
				const startMinutes: number = parseInt(
					this.selectedHourFrom.split(':')[1],
					10
				);
				const endHours: number = parseInt(
					this.selectedHourTo.split(':')[0],
					10
				);
				const endMinutes: number = parseInt(
					this.selectedHourTo.split(':')[1],
					10
				);

				const startDate = moment(this.sessionDate)
					.hours(startHours)
					.minutes(startMinutes);

				const minDiff = Math.round(startMinutes - endMinutes);
				const hoursDiff =
					startHours > endHours
						? Math.round(endHours + 24 - startHours)
						: Math.round(endHours - startHours);
				const endDate: Date = startDate
					.clone()
					.add(hoursDiff, 'hour')
					.add(minDiff, 'minutes')
					.toDate();

				// Save or update.
				if (this.editMode) {
					const newDate: string = startDate.toISOString();
					const upObject: IUpdateEvent = {
						userId: await this.userService.getUserId(),
						timeZone: this.dateTime.getTimezoneName(),
						startDate: newDate,
						contactReason: this.selectedReasons.map((reason) => reason.id),
					};
					this.updateEvent(this.editId, upObject);
				} else {
					if (this.operationType === 'online') {
						const client = this.selectedClient as SelectedClient;
						const newEvent: INewEvent = {
							professionalId: await this.userService.getUserId(),
							professionalOnline: false,
							price: parseFloat(this.eventPrice),
							startDate: startDate.toISOString(),
							timezone: this.dateTime.getTimezoneName(),
							type: 'invite',
							userId: client.profileId || null,
							contactId: !client.profileId ? client.id : null,
							contactName: client.name || null,
							contactReason: this.selectedReasons.map((reason) => reason.id),
						};
						this.saveNew(newEvent);
					} else {
						const newBusySlot: IBusySlot = {
							startDate: startDate.toDate(),
							endDate: endDate,
							description: this.description,
						};

						this.saveNewBusySlot(newBusySlot);
					}
				}
			} else {
				// Error.
				this.isLoading = false;
			}
		}
	}

	// Validate form.
	public validateForm(): boolean {
		let isValid = true;
		let errorMsg = '';

		if (!this.sessionDate || !this.validadeNewEventDate(this.sessionDate)) {
			errorMsg = this.strNewEvInvalidDate;
			$('#inpNewSessionDate').addClass('fieldError');
			isValid = false;
		} else if (!this.selectedHourFrom) {
			$('#sessionHourFrom').addClass('fieldError');
			errorMsg = this.strInvalidHour;
			isValid = false;
		} else if (!this.selectedHourTo) {
			$('#sessionHourTo').addClass('fieldError');
			errorMsg = this.strInvalidHour;
			isValid = false;
		} else if (this.selectedHourTo <= this.selectedHourFrom) {
			if (this.selectedHourFrom.indexOf(':') > -1) {
				const hF: number = parseInt(this.selectedHourFrom.split(':')[0], 10);
				const hT: number = parseInt(this.selectedHourTo.split(':')[0], 10);
				if (hF < 23 || (hF >= 23 && hT > 1)) {
					errorMsg = this.strNewEvInvalidHour;
					isValid = false;
				}
			} else {
				errorMsg = this.strInvalidHour;
				isValid = false;
			}
			if (!isValid) {
				$('#sessionHourTo').addClass('fieldError');
			}
		} else if (
			!this.editMode &&
			!this.selectedClient &&
			this.operationType === 'online'
		) {
			errorMsg = this.strNewEvInvalidClient;
			isValid = false;
		}
		// Validate hours.
		if (isValid) {
			if (!this.dateTime.validateHour(this.selectedHourFrom)) {
				$('#sessionHourFrom').addClass('fieldError');
				errorMsg = this.strInvalidHour;
				isValid = false;
			} else if (!this.dateTime.validateHour(this.selectedHourTo)) {
				$('#sessionHourTo').addClass('fieldError');
				errorMsg = this.strInvalidHour;
				isValid = false;
			} else if (
				!this.editMode &&
				(this.eventPrice === undefined || this.eventPrice === null) &&
				this.operationType === 'online'
			) {
				$('.inpCurrencyGroup input').addClass('fieldError');
				errorMsg = this.strNewEvInvalidPrice;
				isValid = false;
			}
		}
		if (!isValid) {
			this.notifications.showError(errorMsg, this.strNewSession);
		}
		return isValid;
	}

	// Validate new event date.
	private validadeNewEventDate(date): boolean {
		let isValid = true;
		// Get now.
		const now: Date = new Date();
		// Ignore time.
		now.setHours(0, 0, 0, 0);
		date.setHours(0, 0, 0, 0);
		// Validate.
		isValid = date >= now;
		// Return.
		return isValid;
	}

	// Save new event.
	public saveNewBusySlot(busySlot: IBusySlot): void {
		const title = this.eventTypes.find((e) => e.value === 'personal');
		// Try to save.
		this.availabitiesService.addBusySlot(busySlot).subscribe(
			() => {
				// Message.
				this.notifications.showSuccess(title.label);
				this.eventSaved();
			},
			(e) => {
				this.isLoading = false;
				const { error } = e;
				this.notifications.showError(error.messageI18n, this.strNewSession);
				this.onResize('evDetails');
			}
		);
	}

	// Save new event.
	public saveNew(event: INewEvent): void {
		// Try to save.
		this.events.saveNewEvent(event).subscribe(
			(result) => {
				// Message.
				this.notifications.showSuccess(
					this.strInviteWasSent,
					this.strNewSession
				);
				this.events.updateLocalEvent(result);
				this.eventSaved();
			},
			(e) => {
				// Loaded.
				this.isLoading = false;
				const { error } = e;
				let title = this.strNewSession;
				const message = error.messageI18n || '';
				if (message.startsWith('Configure seus dados de faturamento')) {
					title = this.translate.instant(
						'SCHEDULE.ERROR_WITHOUT_FINANCIAL_PROFILE'
					);
				}
				this.notifications.showError(error.messageI18n, title);
				this.onResize('evDetails');
			}
		);
	}
	public async saveEvent() {
		const eventId: string = this.editId;
		const userId: string = await this.userService.getUserId();
		if (eventId && userId) {
			this.confirmEventFinish();
		}
	}

	// Save event Tag
	public async updateEventReasons() {
		const eventId: string = this.editId;
		const userId: string = await this.userService.getUserId();
		if (eventId && userId) {
			const upObject: IUpdateEvent = {
				contactReason: this.selectedReasons.map((reason) => reason.id),
			};
			this.translate
				.get([
					'MESSAGES.SAVEDSUCCESSFULLY',
					'MESSAGES.SAVEDERROR',
					'MESSAGES.UNSELECTEDREASON',
				])
				.subscribe((res) => {
					if (this.selectedReasons.length === 0) {
						this.notifications.showError(
							res['MESSAGES.UNSELECTEDREASON'],
							res['MESSAGES.SAVEDERROR']
						);
						return;
					}
					this.isLoading = true;
					this.events.confirmEventFinish(eventId, upObject).subscribe(
						() => {
							this.notifications.showSuccess(res['MESSAGES.SAVEDSUCCESSFULLY']);
							// Loaded.
							this.isLoading = false;
							// Update local event
							this.editEvent.contactReason = upObject.contactReason;
							this.events.updateLocalEvent(this.editEvent);
						},
						(error) => {
							// Loaded.
							this.isLoading = false;
							// Message.
							this.notifications.showError(error, res['MESSAGES.SAVEDERROR']);
						}
					);
				});
		}
	}

	// Update an existing event.
	public updateEvent(eventId: string, event: IUpdateEvent): void {
		// Try to save.
		this.events.updateEvent(eventId, event).subscribe(
			() => {
				this.notifications.showSuccess(
					this.strInviteWasSent,
					this.strReschedule
				);
				this.eventSaved(event.startDate);
			},
			(e) => {
				const { error } = e;
				this.isLoading = false;
				this.notifications.showError(error.messageI18n, this.strNewSession);
			}
		);
	}

	// Event saved/updated.
	private eventSaved(eventDate?: string): void {
		if (eventDate) {
			const minDate = moment.utc(eventDate).startOf('day');
			const maxDate = moment.utc(eventDate).endOf('day');
			this.events.updateLocalEvents({ minDate, maxDate }).then(() => {
				this.isLoading = false;
				this.goToPage('calendar', eventDate);
			});
		} else {
			this.isLoading = false;
			this.returnToPrevious();
		}
	}

	// Cancel invite.
	public async cancelInvite() {
		const eventId: string = this.editId;
		const userId: string = await this.userService.getUserId();
		if (eventId && userId) {
			// Loader.
			this.isLoading = true;
			this.translate
				.get([
					'SCHEDULE.QUESTIONS.CANCELTHISINVITE',
					'OPERATIONS.CANCELINVITE',
					'OPERATIONS.INVITE_CANCELED',
				])
				.subscribe((res) => {
					const strAreYouSure: string =
						res['SCHEDULE.QUESTIONS.CANCELTHISINVITE'];
					if (confirm(strAreYouSure)) {
						this.events.cancelInvite(eventId).subscribe(
							() => {
								this.notifications.showSuccess(
									res['OPERATIONS.INVITE_CANCELED']
								);
								this.eventSaved(this.sessionDate?.toISOString());
								// Loader.
								this.isLoading = false;
							},
							(error) => {
								this.isLoading = false;
								// Message.
								this.notifications.showError(
									error,
									res['OPERATIONS.CANCELINVITE']
								);
							}
						);
					}
				});
		}
	}

	// Cancel invite.
	public async cancelReschedule() {
		// const eventId: string = this.activeSidebar.id;
		const eventId: string = this.editEvent.reschedule.eventId;
		const userId: string = await this.userService.getUserId();
		if (eventId && userId) {
			this.translate
				.get([
					'SCHEDULE.QUESTIONS.CANCELTHISRESCHEDULE',
					'OPERATIONS.CANCELRESCHEDULE',
				])
				.subscribe((res) => {
					const strAreYouSure: string =
						res['SCHEDULE.QUESTIONS.CANCELTHISRESCHEDULE'];
					const strEvTitle: string = res['OPERATIONS.CANCELRESCHEDULE'];
					if (confirm(strAreYouSure)) {
						// Loader.
						this.isLoading = true;
						this.events.cancelReschedule(eventId).subscribe(
							() => {
								this.notifications.showSuccess(strEvTitle);
								this.eventSaved(this.sessionDate?.toISOString());
								// Loader.
								this.isLoading = false;
							},
							(error) => {
								this.isLoading = false;
								// Message.
								this.notifications.showError(error, strEvTitle);
							}
						);
					}
				});
		}
	}

	// Confirm the event end.
	public confirmEventFinish(): void {
		if (this.editEvent.id) {
			this.translate
				.get([
					'SCHEDULE.QUESTIONS.CONFIRMEVENTSESSION',
					'OPERATIONS.CONFIRMEVENTSESSION',
				])
				.subscribe((res) => {
					const strEvTitle: string = res['OPERATIONS.CONFIRMEVENTSESSION'];
					const upObject: IConfirmEvent = {
						contactReason: this.selectedReasons.map((reason) => reason.id),
					};

					this.isLoading = true;
					this.events.confirmEventFinish(this.editEvent.id, upObject).subscribe(
						() => {
							this.notifications.showSuccess(strEvTitle);
							this.isLoading = false;
						},
						(error) => {
							// Message.
							this.isLoading = false;
							this.notifications.showError(error, strEvTitle);
						}
					);
				});
		}
	}

	// removes a busy slot
	public deleteBusySlot(id: string): void {
		this.isLoading = true;
		this.availabitiesService.removeBusySlot(id).subscribe(() => {
			this.isLoading = false;
			this.goToPage('calendar');
		});
	}

	// Reschedule event.
	public reschedule(): void {
		if (this.allowReschedule) {
			this.rescheduleMode = true;
			this.onResize('evForm');
		}
	}

	getEventStatus(event: ICalendarEvent): string {
		if (event.status) {
			switch (event.status.toLowerCase()) {
				case 'paid':
					if (event.confirmedAt) {
						return this.translate.instant('SCHEDULE.STATUS.FULFILLED');
					}

					return this.translate.instant('SCHEDULE.STATUS.CONFIRMED_YES');
				case 'reserved':
					return this.translate.instant('SCHEDULE.STATUS.WAITINGPAYMENT');
			}
		}
		return event.statusText;
	}

	getPaymentStatus(event: ICalendarEvent): string {
		if (event.status) {
			if (this.originalDateFrom) {
				return `${this.translate.instant('SCHEDULE.RESCHEDULEDFROM')} ${
					this.originalDateFrom
				}`;
			}

			switch (event.status.toLowerCase()) {
				case 'reschedule':
				case 'reschedule_request':
					return this.translate.instant('SCHEDULE.STATUS.PAID');
			}
		}
		return event.statusText;
	}

	getFinalCompensation(event: ICalendarEvent): number | false {
		const finalCompensation = event.compensationFinal;
		return finalCompensation && finalCompensation.compensation !== undefined
			? finalCompensation && finalCompensation.compensation
			: false;
	}

	async showChat(event: ICalendarEvent) {
		const chatUser: IChatUser = {
			id: event.profileId,
			photoUrl: event.userImageUrl,
			username: event.userName,
			role: this.chat.role,
		};
		await this.chat.startConversation(chatUser, 'mobile-appointment-detail');
	}

	checkTriage(event: ICalendarEvent) {
		this.triage$ = this.triageService
			.checkTriage({
				professionalId: event?.professionalId,
				profileId: event?.profileId,
			})
			.pipe(
				take(1),
				tap((triage: CheckTriage) => (this.hasTriage = Boolean(triage)))
			);
	}

	showTriage(triage: CheckTriage) {
		this.triage = {
			...triage,
			mainComplaintText: triage.mainComplaint?.join(','),
		};
		this.showTriageData = true;
	}

	showAppointment() {
		this.showTriageData = false;
	}
}
